// React
import React, { Component } from "react";
import PropTypes from "prop-types";

// Libs
import { Row, Col } from "react-bootstrap";
import { Radio, TextArea } from "shared_components";

// Data
import data from "../data";

// Style
import "./style.css";

class StepTwo extends Component {
  state = {
    selected: ""
  };

  /**
   * Checking if the radio reason input is selected
   * @param  {String} reason
   * @return {Boolean}
   */
  isReasonSelected = reason => {
    return (
      (this.state.selected === reason.title ||
        this.props.cancelReason === reason.title) &&
      "Step_Two_reason_list_selected"
    );
  };

  render() {
    return <div>
        {data.reasonList.map((reason, index) => (
          <Row
            className={`Step_Two_reason_list ${this.isReasonSelected(
              reason
            )}`}
            key={index}
          >
            <Col md={12} className="Step_Two_reason_list_radio">
              <Radio
                title={reason.title}
                value={reason.title}
                name="cancel_reason"
                checked={
                  this.props.cancelReason === reason.title ||
                  this.state.selected === reason.title
                }
                onChange={e => {
                  this.props.onChange(e);
                  this.setState({ selected: e.target.value });
                }}
              />
              {this.props.cancelReason === "Other" &&
                reason.title === "Other" && (
                  <div style={{ marginTop: "7px" }}>
                    <TextArea
                      placeholder="Please tell us more about why Spocket Pro didn’t work for you"
                      name="other_description"
                      value={this.props.cancelReasonDescription}
                      onChange={e => {
                        this.props.onChange(e);
                      }}
                    />
                  </div>
                )}
            </Col>
          </Row>
        ))}
      </div>;
  }
}

StepTwo.propTypes = {
  onChange: PropTypes.func.isRequired,
  cancelReason: PropTypes.string
};

export default StepTwo;



// WEBPACK FOOTER //
// ./src/components/_Shared/Modals/DowngradePlanModal/StepTwo/index.js